import type { ITrendsBarValue } from "pro-features/components/TrendsBar/src/TrendsBar";

import type { PieChartSeries } from "../GAWidget/types";

export enum CreationFlow {
    Suggestion = "suggestion",
    Manual = "manual",
    ImportFromExisting = "importFromExisting",
}

export enum TopicFilters {
    All = "all",
    Inc = "inc",
    Dec = "dec",
    Lead = "lead",
}

export enum TopicSorting {
    ShareOfVoice = "shareOfVoice",
    Vol = "vol",
    ShareChange = "shareChange",
    MostRecent = "mostRecent",
    Name = "name",
}

export interface TopicTrendSchema {
    key: string;
    value: { change?: number; value: number };
}

export interface KeywordShareSchema {
    domain: string;
    shareOfVoice: number;
    shareOfVoiceChange: number;
}

export interface ShortTopicSchema {
    id: string;
    name: string;
    keywords: string[];
}

export type TopicSchema = {
    keywordsCount: number;
    leader: KeywordShareSchema;
    primary: KeywordShareSchema;
    others: {
        share: number;
        competitors: KeywordShareSchema[];
    };
    topicId: string;
    topicName: string;
    trend?: TopicTrendSchema[] | null;
    volume: number;
    created: string;
    volumeChange: number;
    isShared: boolean;
    sharedBy?: string;
} & { isPreloading?: boolean };

export type SuggestionSchema = Pick<TopicSchema, "topicName" | "volume">;

export enum PieChartId {
    Primary = "primary",
    Leader = "leader",
    Others = "others",
}

export type NormalizedTopicSchema = {
    id: string;
    keywordsCount: number;
    name: string;
    shareOfVoice: number;
    shareOfVoiceChange: number;
    leaderName: string;
    primaryName: string;
    leaderShareOfVoice: number;
    leaderIcon: string;
    volume: number;
    volumeChange: number;
    created: Date;
    trend: ITrendsBarValue[];
    pieChartData: PieChartSeries[];
};
export type GetDataSchema = Partial<
    NormalizedTopicSchema & Pick<TopicSchema, "isPreloading" | "isShared" | "sharedBy"> & SuggestionSchema
>;

export interface TopicWithKeywordsSchema {
    name: string;
    keywords: string[];
}

export type TopicsSchema = {
    formattedDuration: string;
    createdTopicsLength: number;
    isViewerMode?: boolean;
};

export type KWGroupSchema = {
    text: string;
    icon: string;
    id: string;
    domains: string[];
    shared: boolean;
    sharedWithAccounts: string[];
    sharedWithUsers: string[];
    userId: string;
};

export type TopicFlagsSchema = {
    inc: boolean;
    dec: boolean;
    lead: boolean;
    all: boolean;
};

export type TopicSortingSchema = {
    id: TopicSorting;
    text: string;
    field: string;
};

export type DownloadExcelBody = {
    country: number;
    KeywordsGroup: string;
};
